import React from "react";
import { Eye, X } from "lucide-react";
import { useApp } from "../AppContext";

/**
 * Compact demo mode banner (no role pills — access is per email invitation instead).
 * Shown only for the demo account. Dismissible.
 */
export default function DemoModeBanner() {
  const { lang, user } = useApp();
  const [visible, setVisible] = React.useState(() => {
    try { return localStorage.getItem("progere_demo_banner_dismissed") !== "1"; } catch { return true; }
  });

  if (!visible || !user?.email?.startsWith("demo@")) return null;
  const isFr = lang === "fr";

  const dismiss = () => {
    setVisible(false);
    try { localStorage.setItem("progere_demo_banner_dismissed", "1"); } catch {/* ignore */}
  };

  return (
    <div className="mb-6 rounded-2xl px-4 py-3 flex flex-wrap items-center gap-3"
      style={{
        background: "linear-gradient(180deg, rgba(24,24,24,0.9), rgba(11,11,11,0.9))",
        border: "1px solid rgba(212,175,55,0.25)",
      }}
      data-testid="demo-banner">
      <div className="flex items-center gap-2 flex-1">
        <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0"
          style={{ background: "rgba(212,175,55,0.15)", border: "1px solid rgba(212,175,55,0.35)" }}>
          <Eye size={14} color="#D4AF37" />
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] font-bold" style={{ color: "#D4AF37" }}>
            {isFr ? "Mode démonstration" : "Demo mode"}
          </div>
          <div className="text-sm" style={{ color: "rgba(245,245,245,0.85)" }}>
            {isFr
              ? "Explorez PROGÈRE Devis AI avec des données fictives. Aucune action réelle n'est effectuée."
              : "Explore PROGÈRE Devis AI with sample data. No real actions are performed."}
          </div>
        </div>
      </div>
      <button onClick={dismiss}
        className="text-xs flex items-center gap-1 px-2 py-1 rounded hover:bg-white/5"
        style={{ color: "rgba(245,245,245,0.55)" }}
        data-testid="demo-banner-close">
        <X size={12} /> {isFr ? "Quitter" : "Exit"}
      </button>
    </div>
  );
}
